<template>
	<div class="cards-search">
		<div class="container">
			<div class="cards-search__search">
				<SimpleTypeahead :items="municipalities" ref="searchInput" placeholder="Zoek naar een gemeente" @selectItem="selectItem" @onInput="onInput"></SimpleTypeahead>
			</div>

			<EmptyState v-if="showEmptyState" @reset="reset" />

			<ul v-else class="cards-search__list">
				<component :is="selectComponent(card.type)" v-for="card in list" :card="card" :searchTerm="searchTerm" :key="card.id"></component>
			</ul>
		</div>
	</div>
</template>

<script>
import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import Office from './Office.vue';
import Region from './Region.vue';
import EmptyState from './EmptyState.vue';

export default {
	name: 'CardsSearch',
	components: {
		Office,
		SimpleTypeahead,
		EmptyState,
		Region,
	},
	data() {
		return {
			searchTerm: '',
			searchInput: '',
			showEmptyState: false,
		};
	},
	props: {
		cards: Array,
	},
	computed: {

		list() {
			if (!this.searchTerm) {
				return this.cards;
			}

			const cards = [];

			this.cards.forEach((card) => {
				if (card.municipalities.includes(this.searchTerm)) {
					cards.push(card);
				}
			});

			return cards;
		},
		municipalities() {
			return [...new Set(this.cards.flatMap((card) => card.municipalities).sort())];
		},
	},
	methods: {
		selectItem(item) {
			this.searchTerm = item;
		},
		onInput({ input, items }) {
			if (!input) {
				this.searchTerm = '';
			}

			this.searchInput = input;

			if (!items.length) {
				this.showEmptyState = true;
			} else {
				this.showEmptyState = false;
			}
		},
		reset() {

			this.$refs.searchInput.clearInput();

			this.showEmptyState = false;
		},
		selectComponent(type) {
			if (type == 'region') {
				return 'Region';
			}

			if (type == 'office') {
				return 'Office';
			}
 		}
	},
};
</script>

<style lang="scss" scoped></style>
